// @ts-nocheck
import 'regenerator-runtime/runtime'
import * as uuid from 'uuid'
import logger from './common/safe-log'
import { initPersistentIdentifier } from './persistentIdentifier'
import EventDataService from './services/eventDataService'
import PixelConfigurationService from './services/pixelConfigurationService'
import everflowTracker from './third-party-trackers/everflow'
import fbTracker from './third-party-trackers/facebook'
import guTracker from './third-party-trackers/giddyupServerSide'
import googleAdsTracker from './third-party-trackers/googleAds'
import gtagTracker from './third-party-trackers/gtagUniversalAnalytics'
import redshiftTracker from './third-party-trackers/redshift'
import snapchatTracker from './third-party-trackers/snapchat'
import tiktokTracker from './third-party-trackers/tiktok'
import VwoTracker from './third-party-trackers/vwo'
import { tryCatchFuncWrapper } from './utils/helpers'
import { getExclusiveDomainParts, getUrlParams } from './utils/urls'
import GA4 from './third-party-trackers/ga4'

window.gu_qs = window.gu_qs || {}
try {
  initPersistentIdentifier()
} catch (e) {
  //console.log(e);
}

if (!window?.ga_account_id) {
  logger.error('Offer GA Pixel ID not configured')
}

GA4.load(window?.gu_ga4_id)
gtagTracker.load(window?.ga_account_id)
fbTracker.load(window?.fb_id)

// Function to fetch the IP address
const fetchIpAddress = async () => {
  try {
    const response = await fetch('https://api64.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.log('Error fetching IPv6 address:', error);
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.log('Error fetching IPv4 address:', error);
      return null;
    }
  }
};

const module = 'TrackingManager'
const TrackingManager = {
  initRetryCount: 0,
  isInitialized: false,
  eventQueue: [],
  initTracking: async () => {
    try {
      TrackingManager.initCorrelationId()
      EventDataService.populateOfferGuParams()
      logger.addGlobalContext(window?.gu_qs)
      // abTastyTracker.initEventHandlers();
      await TrackingManager.setupPixelsAsync()
      TrackingManager.isInitialized = true
      TrackingManager.clearEventQ()
      TrackingManager.fireEvent('Page Start')
    } catch (e) {
      logger.error('initTracking Failed', e, { module })
    }
  },
  clearEventQ: () => {
    try {
      if (window.guEventQ && window.guEventQ.length > 0) {
        for (let i = 0; i < window.guEventQ.length; i++) {
          const event = window.guEventQ[i]
          TrackingManager.fireEvent(
            event.eventName,
            event.action,
            event.identifier,
            event.propertyName,
            event.propertyValue
          )
        }
        window.guEventQ = []
      }
      if (window.guEventWithOrderQ && window.guEventWithOrderQ.length > 0) {
        for (let i = 0; i < window.guEventWithOrderQ.length; i++) {
          const event = window.guEventWithOrderQ[i]
          TrackingManager.fireEventWithOrder(
            event.eventType,
            event.orderObject
          )
        }
        window.guEventWithOrderQ = []
      }
      if (
        TrackingManager?.eventQueue &&
        TrackingManager?.eventQueue.length > 0
      ) {
        for (let i = 0; i < TrackingManager?.eventQueue.length; i++) {
          const event = TrackingManager?.eventQueue[i]
          TrackingManager.fireEvent(
            event.eventName,
            event.action,
            event.identifier,
            event.propertyName,
            event.propertyValue
          )
        }
        TrackingManager.eventQueue = []
      }
    } catch (e) {
      logger.error('clearEventQ Failed', e, { module })
    }
  },
  initCorrelationId: () => {
    window.gu_correlationId = uuid.v4()
  },
  setupPixelsAsync: async () => {
    try {
      TrackingManager.PixelConfiguration =
        await PixelConfigurationService.getPixelConfigurationForCurrentPageAsync()
      logger.info('Pixel Configuration', {
        pixelConfig: TrackingManager.PixelConfiguration,
      })
      //window.gu_ap = TrackingManager.PixelConfiguration;
      //guPixelOverrides.init();

      fbTracker.initAdditional(TrackingManager?.PixelConfiguration?.facebook)
      snapchatTracker.load(TrackingManager?.PixelConfiguration?.snapchat)
      tiktokTracker.load(TrackingManager?.PixelConfiguration?.tiktok)
      googleAdsTracker.load(TrackingManager?.PixelConfiguration?.google)

      // if (window.gu_ap) {
      //     if (window?.gu_ap['fb']) {
      //         fbTracker.initAdditional(window.gu_ap['fb']);
      //     }
      //     if (window?.gu_ap['sc']) {
      //         snapchatTracker.load(window.gu_ap['sc']);
      //     }
      //     if (window?.gu_ap['tt']) {
      //         tiktokTracker.load(window.gu_ap['tt']);
      //     }
      //     if (window?.gu_ap?.['gad'] && window?.gu_ap?.['gadc']) {
      //         googleAdsTracker.load(window.gu_ap['gad'], window.gu_ap['gadc'], window?.gu_ap?.['gadv']);
      //     }
      // }
    } catch (e) {
      logger.error('setupPixelOverrides Failed', e, { module })
    }
  },
  fireClickOffsitePaymentEvent: () => {
    TrackingManager.fireEvent('Shipping Info')
  },
  fireMatchingPageViewEvent: () => {
    try {
      const path = window.location.pathname.toLowerCase()
      if (path.startsWith('/splash')) {
        TrackingManager.fireEvent('Splash Page')
      } else if (path.startsWith('/blog')) {
        TrackingManager.fireEvent('Presell Page')
      } else {
        TrackingManager.fireEvent('Landing Page')
      }
    } catch (e) {
      logger.error('fireMatchingPageViewEvent Failed', e, { module })
    }
  },
  fireMatchingPageStartEvent: () => {
    try {
      const path = window.location.pathname.toLowerCase()
      if (path.startsWith('/splash')) {
        TrackingManager.fireEvent('Splash Page Start')
      } else if (path.startsWith('/blog')) {
        TrackingManager.fireEvent('Presell Page Start')
      } else {
        TrackingManager.fireEvent('Landing Page Start')
      }
    } catch (e) {
      logger.error('fireMatchingPageStartEvent Failed', e, { module })
    }
  },

  fireEvent: (
    eventName,
    action,
    identifier,
    propertyName,
    propertyValue,
    pagePath,
    propertyMeta
  ) => {
    try {
      if (!TrackingManager.isInitialized) {
        const queuedEvent = {
          eventName,
          action,
          identifier,
          propertyName,
          propertyValue,
          pagePath,
          propertyMeta
        }
        TrackingManager.eventQueue.push(queuedEvent)
      } else {
        let eventProperties

        if (
          window?.gu_qs?.gutestpurchase === '1' &&
          eventName === 'Landing Page'
        ) {
          eventName = 'Order Conversion'
          eventProperties = EventDataService.buildTestEventProperties()
        } else {
          eventProperties = EventDataService.buildEventProperties(
            eventName,
            action,
            identifier,
            propertyName,
            propertyValue,
            pagePath,
            propertyMeta
          )
        }

        if (eventName === 'Page View') {
          TrackingManager.fireMatchingPageViewEvent()
          return
        }
        if (eventName === 'Page Start') {
          TrackingManager.fireMatchingPageStartEvent()
          return
        }

        if (window?.gu_qs?.gutestpurchase === '1') {
          logger.debug('Fire Test Tracking Event', { eventProperties })
        } else {
          logger.debug('Fire Tracking Event', { eventProperties })
          everflowTracker.trackEvent(eventProperties)
        }

        fbTracker.trackEvent(eventProperties)
        tiktokTracker.trackEvent(eventProperties)
        snapchatTracker.trackEvent(eventProperties)
        gtagTracker.trackEvent(eventProperties)
        GA4.trackEvent(eventProperties)
        googleAdsTracker.trackEvent(eventProperties)
        guTracker.trackEvent(eventProperties)
        VwoTracker.trackEvent(eventProperties)

        if (eventName !== 'Order Conversion' && eventName !== 'Page View') {
          redshiftTracker.track(eventProperties)
        }

        /* const abTastyEvent = abTastyTracker.trackEvent(eventProperties);
        if (abTastyEvent?.event?.type) {
          if (eventName === 'Order Conversion') {
            abTastyEvent.event_data_category = 'Order Conversion';
            abTastyEvent.order_data = window?.gu_payments?.order;
          }
          guTracker.trackEvent({ eventName: 'comprehensive', ...abTastyEvent });
        }*/
      }
    } catch (e) {
      logger.error('fireEvent Failed', e, { module })
    }
  },
  async guInitPixelConfig(options = {}) {
    try {
      logger.debug('Invoked guInitPixelConfig()', options)
      let pixelConfig
      const { brandName = 'default', affiliateId, offerId } = options

      pixelConfig =
        await PixelConfigurationService.getPixelConfigFromBrandNameAndAffIdAndOId(
          brandName,
          affiliateId,
          offerId
        )

      if (!pixelConfig) {
        logger.info('No pixelConfigs found!', options)
        console.log('No pixelConfigs found!', { options })
        return false
      }

      TrackingManager.PixelConfiguration = pixelConfig

      logger.info('Pixel Configuration', {
        pixelConfig: TrackingManager.PixelConfiguration,
      })

      // Init the different clients
      fbTracker.initAdditional(TrackingManager?.PixelConfiguration?.facebook)
      snapchatTracker.load(TrackingManager?.PixelConfiguration?.snapchat)
      tiktokTracker.load(TrackingManager?.PixelConfiguration?.tiktok)
      googleAdsTracker.load(TrackingManager?.PixelConfiguration?.google)

      console.log('success guInitPixelConfig()')
      return true
    } catch (error) {
      console.log('failed guInitPixelConfig()', { error })
      logger.error('Error in guInitPixelConfig()', { error, options })
      return false
    }
  },
  async guInitPixelFromCustomDomain(customDomain) {
    try {
      const { brandName } = getExclusiveDomainParts(customDomain)
      const { aff_id, oid, req_id } = getUrlParams(customDomain)

      window.gu_qs = window.gu_qs || {}
      window.gu_qs['req_id'] = req_id
      window.gu_qs['externalId'] = req_id

      return await this.guInitPixelConfig({
        brandName,
        affiliateId: aff_id,
        offerId: oid,
      })
    } catch (error) {
      console.log('failed guInitPixelFromCustomDomain()', { error })
      logger.error('Error in guInitPixelFromCustomDomain()', {
        error,
        customDomain,
      })
      return false
    }
  },
  async fireEventWithOrder(eventName = 'Order Conversion', order = {}) {
    try {
      console.log('invoked fireEventWithOrder()', order)
      let { customer = {}, attribute = {}, name: order_id, billingAddress = {}, propertyValue = '', propertyMeta = {} } = order;

      if (!billingAddress) {
        billingAddress = {}
      }

      const { firstName = '', lastName = '', email = '', phone = '' } = customer;
      const { country_code: countryCd, city, province, province_code: provinceCd, zip: zipCd } = billingAddress || {};
      const { customDomain = '', guQs = '' } = attribute;
      const customDomainUrlParams = getUrlParams(customDomain) || {};
      const guQsBase64Decoded = tryCatchFuncWrapper({ func: atob, args: [guQs], defaultOnFail: '{}' });
      const guQsParsed = tryCatchFuncWrapper({ func: JSON.parse, args: [guQsBase64Decoded], defaultOnFail: {} });
      console.log('guQs', guQsParsed)
      console.log('customDomainUrlParams', customDomainUrlParams)
      const { br: brand = '' } = guQsParsed;

      let eventProperties = {};
      eventProperties = Object.assign(eventProperties, customDomainUrlParams);
      eventProperties = Object.assign(eventProperties, guQsParsed);

      const req_id = eventProperties['req_id'] || uuid.v4()
      logger.info('eventProperties before manual assign', {eventProperties})

      eventProperties['mobileDevice'] = window.mobileDevice
      eventProperties['req_id'] = req_id
      eventProperties['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
      eventProperties.enhancedConversionData = {
        email,
        unformatted_phone_number: phone,
        first_name: firstName,
        last_name: lastName,
        home_address: {
          city,
          region: province,
          postal_code: zipCd,
          country: countryCd,
        },
      }
      eventProperties['externalId'] = req_id
      eventProperties['eventId'] = req_id
      eventProperties['brand'] = brand
      eventProperties['br'] = brand
      eventProperties['postalCode'] = zipCd
      eventProperties['region'] = province
      eventProperties['regionCode'] = provinceCd
      eventProperties['url'] = customDomain
      eventProperties['landingSite'] = customDomain
      eventProperties['eventName'] = eventName
      eventProperties['email'] = email
      eventProperties['phone'] = phone
      eventProperties['firstName'] = firstName
      eventProperties['lastName'] = lastName
      eventProperties['order_id'] = order_id
      eventProperties['userAgent'] = navigator?.userAgent

      // Fetch IP address and set it in eventProperties
      eventProperties['ipAddress'] = await fetchIpAddress();

      logger.info('event properties -> ', {eventProperties} );

      fbTracker.trackEvent(eventProperties)
      guTracker.trackEvent(eventProperties)
      tiktokTracker.trackEvent(eventProperties)
      snapchatTracker.trackEvent(eventProperties)
      gtagTracker.trackEvent(eventProperties)
      googleAdsTracker.trackEvent(eventProperties)

      eventProperties['propertyValue'] = propertyValue
      eventProperties['propertyMeta'] = propertyMeta
      GA4.trackEvent(eventProperties)
      return true
    } catch (error) {
      logger.error('Error in fireEventWithOrder()', { error, order })
      return false
    }
  },
}

window.gu_fire_event = TrackingManager.fireEvent
window.gu_init_pixel_config = TrackingManager.guInitPixelConfig
window.init_pixel_from_custom_domain =
  TrackingManager.guInitPixelFromCustomDomain.bind(TrackingManager)
window.gu_fire_event_with_order = TrackingManager.fireEventWithOrder

TrackingManager.initTracking()
export { TrackingManager }
